import React from 'react'
import ReactDOM from 'react-dom'
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import LogRocket from 'logrocket'
import setupLogRocketReact from 'logrocket-react'
import { LOGROCKET, LOGROCKET_PROJECT, SENTRY_DSN } from './config';

import App from './App'
import './index.css'

import { registerLocale, setDefaultLocale } from "react-datepicker"
import ptBr from 'date-fns/locale/pt-BR'
registerLocale('ptBr', ptBr)
setDefaultLocale('ptBr')

const rootNode = document.getElementById('root')

// ⚠️ Sentry só inicializa se o DSN estiver configurado via .env
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

if (LOGROCKET === 'true' && LOGROCKET_PROJECT) {
  LogRocket.init(`${LOGROCKET_PROJECT}`)
  setupLogRocketReact(LogRocket)

  LogRocket.getSessionURL(sessionURL => {
    Sentry.configureScope(scope => {
      scope.setExtra('sessionURL', sessionURL)
    })
  })
}


ReactDOM.render(
  <App />,
  rootNode
)

rootNode.setAttribute('data-react-app-version', process.env.REACT_APP_VERSION)
